import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/client/reservation';
const list = (
	systemSource,
	merchantId,
	branchId,
	processType = 1,
	startBookingDate = null,
	endBookingDate = null
) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/order/list`), {
		merchantId,
		branchId,
		startBookingDate,
		endBookingDate,
		processType,
	});
};

const find = (systemSource, merchantId, branchId, reservationId) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/order/detail`), {
		merchantId,
		branchId,
		reservationId,
	});
};

const place = (systemSource, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/place`),
		payload
	);
};

const modify = (systemSource, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/modify`),
		payload
	);
};

const migrateTable = (
	systemSource,
	merchantId,
	branchId,
	reservationId,
	tableCode,
	agreeOverbook,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/modify/table`),
		{
			merchantId,
			branchId,
			reservationId,
			tableCode,
			agreeOverbook,
			operateBy,
		}
	);
};

const swapTable = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/swap-table`),
		data
	);
};

const cancel = (
	systemSource,
	merchantId,
	branchId,
	reservationId,
	amount,
	operateBy,
	reason = ''
) => {
	return Client.post(systemSourceUrl(systemSource, `${baseUrl}/order/cancel`), {
		merchantId,
		branchId,
		reservationId,
		amount,
		reason,
		operateBy,
	});
};

const accept = (
	systemSource,
	merchantId,
	branchId,
	reservationId,
	operateBy
) => {
	return Client.post(systemSourceUrl(systemSource, `${baseUrl}/order/accept`), {
		merchantId,
		branchId,
		reservationId,
		operateBy,
	});
};

const checkin = (
	systemSource,
	merchantId,
	branchId,
	reservationId,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/check-in`),
		{
			merchantId,
			branchId,
			reservationId,
			operateBy,
		}
	);
};

const undoCheckin = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/order/undo-check-in`),
		data
	);
};

const avaliableTime = (
	systemSource,
	merchantId,
	branchId,
	numberOfPeople,
	bookingDate
) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/reserve-time-list`),
		{
			branchId,
			numberOfPeople,
			bookingDate,
		}
	);
};

const tags = (systemSource, merchantId, branchId) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/tags`), {
		merchantId,
		branchId,
	});
};

const estRefund = (systemSource, merchantId, branchId, reservationId) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/refund-deposit`),
		{
			merchantId,
			branchId,
			reservationId,
		}
	);
};

const tablesets = (systemSource, merchantId, branchId, areaCode) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/table-picture`), {
		merchantId,
		branchId,
		areaCode,
	});
};

const tablesetStatus = (
	systemSource,
	merchantId,
	branchId,
	numberOfPeople,
	startTime,
	endTime,
	tagId
) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/table-booking-status`),
		{
			merchantId,
			branchId,
			numberOfPeople,
			startTime,
			endTime,
			tagId,
		}
	);
};

const allocateTable = (systemSource, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/table-ai-booking`),
		data
	);
};

const rule = (systemSource, merchantId, branchId) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/setting-info`), {
		merchantId,
		branchId,
	});
};

const depositRule = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/deposit-setting`),
		{
			merchantId,
			branchId,
		}
	);
};

const reservedNumberOfPeople = (
	systemSource,
	merchantId,
	branchId,
	startTime,
	endTime
) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/reserved-number`),
		{
			merchantId,
			branchId,
			startTime,
			endTime,
		}
	);
};

export default {
	list,
	find,
	place,
	modify,
	migrateTable,
	swapTable,
	accept,
	checkin,
	undoCheckin,
	cancel,
	avaliableTime,
	tags,
	estRefund,
	tablesets,
	tablesetStatus,
	allocateTable,
	rule,
	depositRule,
	reservedNumberOfPeople,
};
